module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sidebar/sidebar.component.css
// module id = ./src/app/components/sidebar/sidebar.component.css
// module chunks = main